import React from "react";
import { Container, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import background from "../assets/img/Hintergrund1_16_9.png";
import minbackground from "../assets/img/minimized/Hintergrund1_16_9.png";
import res_bg from "../assets/img/responsive_backgrounds/new/Responsive_Hintergrund1.png";
import min_res_bg from "../assets/img/responsive_backgrounds/new/Responsive_Hintergrund1.png";
import logo from "../assets/img/logos/Logo.svg";
import Section from "./Section";
import priceTagImage from "../assets/img/Etikett_Preis_ot.png";
import qrPhone from "../assets/img/QRCode/Qr-phone.png";
import buttonPhone from "../assets/img/QRCode/Responsive_Handy_Testtour.png";
import qrMaterial from "../assets/img/QRCode/Printmaterial.png";
import qrArrow from "../assets/img/QRCode/Schrift & Pfeil.png";
import Button from "react-bootstrap/Button";
import { useScreenWidth } from "../ScreenWidthContext";
import DoubleArrowDown from "./subcomponent/DoubleArrowDown";
import phoneIcon from "../assets/img/icon/Telefon.svg";

const TestGameLink = 'https://webapp.tabgame.de/?e=56228&d=MTQ4MzMyXzQ4NjU4ZTQ2Nzg1NTA2ODVlZDMzZTY4Y2NkOTlmMzgyNjQyNWMxYzJfNTYyMjhfYXV0b0xvZ2lu';

export function hidemenu(e, force = false) {
  /*if (isMobile) {
    hidemenumobile(e, force);
    return;
  }*/
  var burgerSymbol = document.getElementById("burgerSymbol");
  var phoneSymbol = document.getElementById("phoneSymbol");
  var navBar = document.getElementById("navbar");
  if (
    force ||
    (navBar.classList.contains("show") &&
      navBar.getBoundingClientRect().width < e.clientX)
  ) {
    burgerSymbol.classList.remove("clicked");
    navBar.classList.remove("show");
    phoneSymbol.style.display = null;
    phoneSymbol.classList.remove("hide");
  }
}

export function hidemenumobile(e, force = false) {
  var burgerSymbol = document.getElementById("burgerSymbol");
  var navBar = document.getElementById("navbar");
  if (
    force ||
    (navBar.classList.contains("show") &&
      navBar.getBoundingClientRect().width < e.clientX)
  ) {
    burgerSymbol.classList.remove("clicked");
    navBar.classList.remove("show");
  }
}

export function hidemenusub(e, force = false) {
  var burgerSymbol = document.getElementById("burgerSymbol");
  var navBar = document.getElementById("navbar");
  if (
    force ||
    (navBar.classList.contains("show") &&
      navBar.getBoundingClientRect().width < e.clientX)
  ) {
    burgerSymbol.classList.remove("clicked");
    navBar.classList.remove("show");
  }
}

function Welcome() {
  const screenWidth = useScreenWidth();
  let responsive = screenWidth < 600;
  const { t } = useTranslation(["welcome_explore"]);

  window.addEventListener("click", hidemenu);

  const hideYoAss = (e) => {
    var s = document.getElementById("phoneSymbol");
    if (s !== null && s.classList.contains("hide")) {
      s.style.display = "none";
    }
  };

  const scrollHandler = (ev) => {
    var qrPhone = document.getElementById("qrPhone");
    var buttonPhone = document.getElementById("buttonPhone");
    var dad = document.getElementById("welcome-DAD");
    var welcomeImage = document.querySelector("#a-welcome > img");
    var tourPlannerImage = document.querySelector("#a-tourplanner > img");
    if (welcomeImage === null || tourPlannerImage === null) return;
    if (qrPhone){
        if (welcomeImage.getBoundingClientRect().bottom - window.scrollY < 470) {
          if (!qrPhone.classList.contains("phone-hidden")) {
            // Check if it already has class assigned, just in case
            qrPhone.classList.add("phone-hidden");
          }
        } else if (qrPhone.classList.contains("phone-hidden")) {
          qrPhone.classList.remove("phone-hidden");
        }
    }
    if (buttonPhone){
        if (welcomeImage.getBoundingClientRect().bottom - window.scrollY < 470) {
          if (!buttonPhone.classList.contains("phone-hidden")) {
            // Check if it already has class assigned, just in case
            buttonPhone.classList.add("phone-hidden");
          }
        } else if (buttonPhone.classList.contains("phone-hidden")) {
            buttonPhone.classList.remove("phone-hidden");
        }
    }
    if (dad) {
      if (welcomeImage.getBoundingClientRect().bottom - window.scrollY < 470) {
        if (!dad.classList.contains("hidden")) {
          // Check if it already has class assigned, just in case
          dad.classList.add("hidden");
        }
      } else if (dad.classList.contains("hidden")) {
        dad.classList.remove("hidden");
      }
    }
    
  };

  window.addEventListener("scroll", scrollHandler);

  return (
    <Section
      id="a-welcome"
      bg={responsive ? res_bg : background}
      minbg={responsive ? min_res_bg : minbackground}
    >
      <object type="image/svg+xml" className="welcome-logo" data={logo} />

      <div className="price-tag" style={{display: "none"}}>
        <img
          src={priceTagImage}
          alt="Preisschild"
          className="price-tag-image"
        />
        <div className="price-tag-text-container">
          <div>
            <div className="price-tag-text">14,90€</div>
            <div className="price-tag-text-desc">PRO SCHÜLER</div>
          </div>
        </div>
      </div>

      <div className="qr-phone" id="qrPhone">
        <img src={qrMaterial} alt="Material" className="qr-material" />
        <img src={qrArrow} alt="Arrow" className="qr-arrow" />
        <img src={qrPhone} alt="QR-Code" className="qr-phone-image" onClick={() => window.open(TestGameLink, '_blank')} />
      </div>

      <div className="button-phone" id="buttonPhone">
          <img src={qrMaterial} alt="Material" className="button-qr-material" />
          <img src={qrArrow} alt="Arrow" className="button-qr-arrow" />
          <div className="button-phone-div">
            <img src={buttonPhone} alt="Demo" className="button-phone-image" />
            <Button className="button-phone-description" 
              onClick={() => window.open(TestGameLink, '_blank')}>
              {t("project_genesis.welcome.phone_button_text")}
            </Button>
          </div>
      </div>

      {screenWidth > 950 ? (
        <div className="welcome-headline">
          <h1 className="smaller-line">
            {t("project_genesis.welcome.big-headline-a")}
          </h1>
          <h2 className="smaller-line" style={{textTransform: "uppercase"}}>
            {t("project_genesis.welcome.big-headline-b")}
          </h2>
        </div>
      ) : (
        <div className="alternative-welcome-headline">
            <h1 className="a">
            {t("project_genesis.welcome.alt-headline-a")}
          </h1>
          <h2 className="b">
            {t("project_genesis.welcome.alt-headline-b")}
          </h2>
        </div>
      )}
      {screenWidth < 950 && <>
        <DoubleArrowDown id="welcome-DAD" className="DoubleArrowDown-welcome" onClick={() => {
          document.getElementById("a-presentation").scrollIntoView();
        }}>{t('project_genesis.welcome.more')}</DoubleArrowDown>
        <a className="phone-number-responsive" href={"tel:" + t("project_genesis.welcome.phone_number")}><img src={phoneIcon}></img>{t("project_genesis.welcome.phone_number")}</a>
        </>
      }
      <div
        className="phone-div"
        id="phoneSymbol"
        onClick={(ev) => {
          if (!ev.target.classList.contains("hide")) {
            document.location.href =
              "tel:" + t("project_genesis.welcome.phone_number");
          }
        }}
        onTransitionEnd={hideYoAss}
      >
        <div className="phone"></div>
        <span className="phone-tooltip">
          {t("project_genesis.welcome.phone_number")}
        </span>
      </div>
    </Section>
  );
}

export default Welcome;
